module.exports = __webpack_public_path__ + "static/img/sabrina.b565c5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/sabrina.png
// module id = YJ2n
// module chunks = 0